import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputLabel,
  MenuItem,
  TextField,
  Select,
  Grid,
  Autocomplete,
  Typography
} from "@mui/material";
import Button from "@mui/material/Button";

//context
import { useAuth } from "../../context/AuthContext";

//theme
import themes from "../../themes/defaultTheme";

export default function InputDialog({
  open,
  onClose,
  title,
  type,
  confirmationBtnName,
  onConfirm,
  inputField1: initialInputField1,
  inputField2: initialInputField2,
  inputField3: initialInputField3,
  regionsDrpDwnVal = null,
  strategyTypesDrpDwnVal = null
}) {
  const { auth } = useAuth();
  const [inputField1, setInputField1] = useState(initialInputField1 || "");
  const [inputField2, setInputField2] = useState(initialInputField2 || "");
  const [inputField3, setInputField3] = useState(initialInputField3 || "");

  useEffect(() => {
    setInputField1(initialInputField1);
    setInputField2(initialInputField2);
    setInputField3(initialInputField3);
  }, [initialInputField1, initialInputField2, initialInputField3]);

  //Invoked when value in input field 1 changes.
  const handleInputField1Change = (event) => {
    setInputField1(event.target.value);
  };

  //Invoked when value in input field 2 changes.
  const handleInputField2Change = (event) => {
    setInputField2(event.target.value);
  };

  //Invoked when value in input field 3 changes.
  const handleInputField3Change = (value) => {
    setInputField3(value);
  };

  const handleCancel = (event) => {
    setInputField1("");
    setInputField2("");
    setInputField3("");
    onClose();
  };

  const handleConfirm = (event) => {
    onConfirm(inputField1, inputField2, inputField3, () => {
      setInputField1("");
      setInputField2("");
      setInputField3("");
    });
  };

  const label1 = (() => {
    if (type && type === "Strategy Types") {
      return "Strategy Name";
    }
    else if (type && type === "Region") {
      return "Region Name";
    }
    else {
      return "";
    }
  })();

  const label3 = (() => {
    if (type && type === "Strategy Types") {
      if (strategyTypesDrpDwnVal) {
        const strategyTypesNone = ["None"]
        const strategyTypesDropDwnOptions = strategyTypesDrpDwnVal.map(type => type.name);
        return ["Parent Category", [...strategyTypesNone, ...strategyTypesDropDwnOptions]]
      }
      else
        return null;
    }
    else if (type && type === "Region") {
      if (regionsDrpDwnVal) {
        const sisterRegionNone = ["None"]
        const sisterRegionOptions = regionsDrpDwnVal.map(reg => reg.name);
        return ["Sister Region", [...sisterRegionNone, ...sisterRegionOptions]];
      }
      else
        return null;
    }
    else
      return null;
  })();

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          onClose(event, reason);
        }
      }}
      aria-labelledby="dialog-title">
      <DialogTitle id="dialog-title" style={{ textAlign: "center", fontWeight: "bold" }}>
        {title}
      </DialogTitle>
      <DialogContent>
        <Typography variant="caption" color="textSecondary">
          Fields marked with <em style={{ color: themes.default.palette.error.dark }}>*</em> are required.
        </Typography>
        <Grid container spacing={2} sx={{ marginTop: "5px" }}>

          {/* Label1 and Textfield */}
          <Grid item xs={6}>
            <InputLabel htmlFor="label1-input" id="label1-text-label">{label1}<em style={{ color: themes.default.palette.error.dark }}>*</em></InputLabel>
          </Grid>
          <Grid item xs={6}>
            <TextField
              id="label1-input"
              fullWidth
              multiline
              rows={2}
              variant="outlined"
              value={inputField1}
              onChange={handleInputField1Change}
              InputProps={{
                inputComponent: 'textarea'
              }}
              inputProps={{
                'aria-labelledby': 'label1-text-label'
              }}
            />
          </Grid>

          {/* Description Label and Textfield */}
          <Grid item xs={6}>
            <InputLabel id="description-label" htmlFor="description-text">
              Description
            </InputLabel>
          </Grid>
          <Grid item xs={6}>
            <TextField
              id="description-text"
              fullWidth
              multiline
              rows={4}
              variant="outlined"
              value={inputField2}
              onChange={handleInputField2Change}
              InputProps={{
                inputComponent: 'textarea'
              }}
              inputProps={{
                id: 'description-text',
                'aria-labelledby': 'description-label'
              }}
            />
          </Grid>

          {/* Label 3 and Drop Down */}
          {label3 && (
            <>
              <Grid item xs={6}>
                <InputLabel id="label3-select-label" htmlFor="label3-input">
                  {label3[0]}
                </InputLabel>
              </Grid>
              <Grid item xs={6}>
                <Autocomplete
                  id="label3-input"
                  options={label3[1]}
                  value={inputField3 || ""}
                  onChange={(event, newValue) => {
                    handleInputField3Change(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      inputProps={{
                        ...params.inputProps,
                        "aria-labelledby": "label3-select-label",
                      }}
                    />
                  )}
                />
              </Grid>
            </>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel}>
          Cancel
        </Button>
        <Button type="submit" onClick={handleConfirm} color="primary">
          {confirmationBtnName}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
